import { supabase } from "@/integrations/supabase/client";

export async function logFormError(
  formName: string,
  error: unknown,
  formData?: Record<string, unknown>
) {
  try {
    const errorMessage =
      error instanceof Error ? error.message : String(error);
    const errorDetails =
      error instanceof Error
        ? { name: error.name, stack: error.stack }
        : { raw: String(error) };

    // Strip sensitive fields before logging
    const safeFormData = formData
      ? Object.fromEntries(
          Object.entries(formData).filter(
            ([k]) => !["password", "token", "secret"].includes(k.toLowerCase())
          )
        )
      : undefined;

    await (supabase.from("form_submission_errors") as any).insert({
      form_name: formName,
      error_message: errorMessage,
      error_details: errorDetails,
      user_agent: navigator.userAgent,
      page_url: window.location.href,
      form_data: safeFormData ?? null,
    });
  } catch (logErr) {
    // Never let logging itself break the UX
    console.error("Failed to log form error:", logErr);
  }
}
